import { ArrayField } from 'react-hook-form';

import { DosageStageUnion, DosageStageValidation, FrequencyDosageCycle } from '~libs.shared.prescription';

import { ExtendedDosageFormController } from '../ExtendedDosageForm.types';

import { DosageBreakField } from './DosageBreakField';
import { FrequencyDosageCycleField } from './FrequencyDosageCycleField';
import { TimesOfDayDosageCycleField } from './TimesOfDayDosageCycleField';

type StageFieldBodyProps = Pick<ExtendedDosageFormController, 'register' | 'watch' | 'setValue' | 'trigger'> & {
   readonly field: Partial<ArrayField<DosageStageUnion>>;
   readonly index: number;
   readonly validation: DosageStageValidation;
   readonly portionUnit: string | null;
};

export const StageFieldBody = (props: StageFieldBodyProps): JSX.Element => {
   if (props.field.class === 'DosageBreak') {
      return (
         <DosageBreakField
            register={props.register}
            watch={props.watch}
            trigger={props.trigger}
            field={props.field}
            index={props.index}
         />
      );
   }

   if (props.field.class === 'TimesOfDayDosageCycle') {
      return (
         <TimesOfDayDosageCycleField
            register={props.register}
            watch={props.watch}
            trigger={props.trigger}
            field={props.field}
            index={props.index}
            validation={props.validation}
            portionUnit={props.portionUnit}
         />
      );
   }

   return (
      <FrequencyDosageCycleField
         register={props.register}
         watch={props.watch}
         setValue={props.setValue}
         trigger={props.trigger}
         field={props.field as Partial<FrequencyDosageCycle>}
         index={props.index}
         validation={props.validation}
         portionUnit={props.portionUnit}
      />
   );
};
